import { observer } from 'mobx-react-lite';

import type { AlertsManagerWidgetState } from '../AlertsManagerWidgetState';
import { AutoAnomaliesTable } from '../auto-anomalies/AutoAnomaliesTable';
import type { AutoAnomaliesViewController, ViewStore } from '../stores/ViewStore';

type Props = {
  viewStore: ViewStore;
  controller: AutoAnomaliesViewController;
  widgetState: AlertsManagerWidgetState;
};

export const AutoAnomalyView = observer(function AutoAnomalyView({ viewStore, controller, widgetState }: Props) {
  return <AutoAnomaliesTable viewStore={viewStore} service={controller.service} widgetState={widgetState} />;
});
